<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex mt-3">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">
            {{ $t('reports.common.searching_period') }}: {{ searching_period[0].format('DD MMMM YYYY') }} - {{ searching_period[1].format('DD MMMM YYYY') }}
          </h5>
        </div>
        <div class="d-flex flex-column justify-content-center ml-auto">
          <a
            href="#"
            target="_blank"
            @click.prevent.stop="downloadExcel"
          >{{ $t('reports.common.excel_export') }} <a-icon type="download" /></a>
        </div>
      </div>
      <div class="card-body">
        <a-table
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          bordered
          :row-key="record => record.id"
          :row-class-name="renderRowClass"
          @change="handleTableChange"
        >
          <div
            slot="filterDate"
            class="custom-filter-dropdown"
          >
            <a-range-picker
              v-model="searching_period"
              :show-time="false"
              @change="handleDateFilter"
            >
              <a-icon
                slot="suffixIcon"
                type="smile"
              />
            </a-range-picker>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />

          <template
            slot="seller_company"
            slot-scope="s"
          >
            <router-link
              :to="`/admin/seller/stores/${s.hash_id}`"
              class="btn btn-sm btn-light"
            >
              {{ $l(s.title) }}
            </router-link>
          </template>

          <template
            slot="type"
            slot-scope="text"
          >
            <strong>{{ $l(text) }}</strong>
          </template>

          <template
            slot="payment_type"
            slot-scope="text"
          >
            <span
              v-if="text === 'ONLINE'"
              class="badge mr-2 badge-primary"
            >
              {{ $t('orders.payment_type.online') }}
            </span>
            <span
              v-else
              class="badge mr-2 badge-secondary"
            >
              {{ $t('orders.payment_type.on_premise') }}
            </span>
          </template>

          <template
            slot="count_non_null"
            slot-scope="text"
          >
            <span v-if="text"> {{ text }} </span>
            <span v-else> 0 </span>
          </template>

          <template
            slot="money"
            slot-scope="text"
          >
            <span v-if="text === 0"> 0 </span>
            <span v-else-if="text"> {{ text | money }} </span>
            <span v-else> - </span>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import reportService from '@/services/api/admin/reports/report-services'
import excelReportService from '@/services/api/admin/reports/excel-report-services'

export default {
  name: 'TotalTurnover',
  components: {
  },
  data: function () {
    return {
      searching_period: [moment().startOf('month'), moment().endOf('month')],
      columns: [
        {
          title: this.$t('reports.common.date'),
          dataIndex: 'date',
          sorter: true,
          scopedSlots: { filterDropdown: 'filterDate' },
          customRender: (value, row, index) => {
            return {
              children: this.data && this.data.length === index + 1 ? this.$t('reports.common.total') : value,
              attrs: {},
            }
          },
        },
        {
          title: this.$t('reports.common.payment_type.offline'),
          children: [
            {
              title: this.$t('reports.turnovers.count'),
              dataIndex: 'offline_payment_sum.count',
              scopedSlots: { customRender: 'count_non_null' },
            },
            {
              title: this.$t('reports.common.total_cost'),
              dataIndex: 'offline_payment_sum.product_cost_sum',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.common.delivery_cost'),
              dataIndex: 'offline_payment_sum.delivery_cost_sum',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.common.buyer_commission'),
              dataIndex: 'offline_payment_sum.buyer_commission_sum',
              scopedSlots: { customRender: 'money' },
            },
          ],
        },
        {
          title: this.$t('reports.common.payment_type.online'),
          children: [
            {
              title: this.$t('reports.turnovers.count'),
              dataIndex: 'online_payment_sum.count',
              scopedSlots: { customRender: 'count_non_null' },
            },
            {
              title: this.$t('reports.common.total_cost'),
              dataIndex: 'online_payment_sum.product_cost_sum',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.common.delivery_cost'),
              dataIndex: 'online_payment_sum.delivery_cost_sum',
              scopedSlots: { customRender: 'money' },
            },
          ],
        },
      ],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 50,
      },
      filter: {
        title: '',
      },
      sorting: {
        col: 'date',
        order: 'asc',
      },
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.filter.date_from = this.searching_period[0].format('YYYY-MM-DD')
      this.filter.date_to = this.searching_period[1].format('YYYY-MM-DD')
      reportService.getTurnovers(this.pagination, this.sorting, this.filter)
        .then((response) => {
          if (response && response.data && response.data.content) {
            this.data = response.data.content
            this.pagination.total = response.data.pagination.total
          }
        })
    },
    handleDateFilter(dates, dateStrings) {
      console.log('invoked on change')
      this.searching_period = dates
      this.fetchData()
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    handleTableChange(pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }
      else
        this.sorting = null

      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length === 1)
          this.filter[key] = filter[key][0]
        else
          this.filter[key] = null
      })

      this.pagination.current = pagination.current

      this.fetchData()
    },
    renderRowClass (record, index) {
      if (this.data && this.data.length === index + 1) {
        return 'custom-summary-class'
      }
    },
    downloadExcel() {
      this.filter.date_from = this.searching_period[0].format('YYYY-MM-DD')
      this.filter.date_to = this.searching_period[1].format('YYYY-MM-DD')
      const fileName = 'Turnovers ' + this.filter.date_from + ' - ' + this.filter.date_to + '.xlsx'
      excelReportService.getTurnoversExcel(this.pagination, this.sorting, this.filter, fileName)
    },
  },
}
</script>

<style>
.custom-summary-class {
  background: #f0f2f4;
}
</style>
